"use client";

import { c as _c } from "react/compiler-runtime";
import { useDropCurationMutation, type DropCurationTarget } from "@/hooks/drops/useDropCurationMutation";
import type { MouseEvent } from "react";
interface DropCurationButtonProps extends DropCurationTarget {
  readonly className?: string | undefined;
}
export default function DropCurationButton(t0) {
  const $ = _c(20);
  const {
    dropId,
    waveId,
    isCuratable,
    isCurated,
    className
  } = t0;
  const {
    toggleCuration,
    isPending
  } = useDropCurationMutation();
  let t1;
  if ($[0] !== dropId) {
    t1 = dropId.startsWith("temp-");
    $[0] = dropId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isTemporaryDrop = t1;
  const isDisabled = isPending || isTemporaryDrop;
  if (!isCuratable) {
    return null;
  }
  let t2;
  if ($[2] !== dropId || $[3] !== isCuratable || $[4] !== isCurated || $[5] !== toggleCuration || $[6] !== waveId) {
    t2 = e => {
      e.stopPropagation();
      toggleCuration({
        dropId,
        waveId,
        isCuratable,
        isCurated
      });
    };
    $[2] = dropId;
    $[3] = isCuratable;
    $[4] = isCurated;
    $[5] = toggleCuration;
    $[6] = waveId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClick = t2;
  const t3 = `tw-flex tw-items-center tw-justify-center tw-gap-x-1 tw-whitespace-nowrap tw-rounded-md tw-border tw-border-solid tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-transition-all tw-duration-300 tw-ease-out ${isCurated ? "tw-text-primary-400 tw-border-primary-400/30 tw-bg-primary-500/10 desktop-hover:hover:tw-bg-primary-500/15" : "tw-border-iron-700 tw-bg-iron-900 tw-text-iron-400 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-text-iron-200"} ${isDisabled ? "tw-cursor-wait tw-opacity-70" : "tw-cursor-pointer"} ${className ?? ""}`;
  const t4 = isCurated ? "Remove curation from drop" : "Curate drop";
  let t5;
  if ($[8] !== isCurated) {
    t5 = isCurated && <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" className="-tw-ml-1 tw-size-3.5 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg"><path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = isCurated;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isCurated ? "Curated" : "Curate";
  let t7;
  if ($[10] !== t6) {
    t7 = <span>{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleClick || $[13] !== isCurated || $[14] !== isDisabled || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t7) {
    t8 = <button type="button" className={t3} onClick={handleClick} disabled={isDisabled} aria-pressed={isCurated} aria-label={t4}>{t5}{t7}</button>;
    $[12] = handleClick;
    $[13] = isCurated;
    $[14] = isDisabled;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}